/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAutoAction } from '../../models/api-response-list-auto-action';

export interface FindDefaultActionSettings$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany: string;
}

export function findDefaultActionSettings(http: HttpClient, rootUrl: string, params: FindDefaultActionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAutoAction>> {
  const rb = new RequestBuilder(rootUrl, findDefaultActionSettings.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('refPhoneCompany', params.refPhoneCompany, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAutoAction>;
    })
  );
}

findDefaultActionSettings.PATH = '/v1/api/ui/auto-actions/{refPhoneCompany}';
